(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/overlay.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/overlay.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const formatTime = svs.utils.date.FormatTime;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _jotai = jotai,
  useAtom = _jotai.useAtom;
const overlayResultAtom = svs.lyckoplatsen.components.shared_result.jotai.atoms.overlayResultAtom;
const ResultDetails = svs.lyckoplatsen.components.shared_result.react.components.ResultDetails;
const Button = svs.ui.ReactButton;
const Overlay = () => {
  const _useAtom = useAtom(overlayResultAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    result = _useAtom2[0],
    setOverlayResult = _useAtom2[1];
  const resultDate = result.regCloseTime;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    animateIn = _useState2[0],
    setAnimateIn = _useState2[1];
  const handleTransitionEnd = () => {
    if (!animateIn) {
      setOverlayResult(null);
    }
  };
  const closeOverlay = () => setAnimateIn(false);
  useEffect(() => {
    setAnimateIn(true);
    const overlayElement = document.querySelector('.result-overlay-content-close');
    if (overlayElement) {
      overlayElement.focus();
    }
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        closeOverlay();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return React.createElement("div", {
    className: "lp-map-result-overlay ".concat(animateIn ? 'animate-in' : '')
  }, React.createElement("div", {
    className: "result-overlay-content",
    onTransitionEnd: handleTransitionEnd
  }, React.createElement("div", {
    className: "result-overlay-content-body"
  }, React.createElement("div", {
    className: "result-overlay-content-header "
  }, Boolean(resultDate) && formatTime('EEEE d/M yyyy', resultDate)), React.createElement(Button, {
    className: "result-overlay-content-close",
    onClick: closeOverlay
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, React.createElement("path", {
    d: "M4.06066 2.93933L3 3.99999L10.955 11.9549L3 19.9099L4.06066 20.9706L12.0156 13.0156L19.9706 20.9706L21.0312 19.9099L13.0763 11.9549L21.0312 3.99999L19.9706 2.93933L12.0156 10.8943L4.06066 2.93933Z"
  }))), React.createElement("div", {
    className: "result-overlay-wrapper"
  }, React.createElement(ResultDetails, {
    result: result,
    showBtnCenterSweden: true
  })))), React.createElement("div", {
    className: "result-overlay-dimmer",
    onClick: closeOverlay
  }));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  Overlay
});

 })(window);